module.exports = __webpack_public_path__ + "static/media/modern_4.75e88344.webp";